import { FC } from "react";
import Tab, { TabProps } from "@/components/Tab";
import SearchAmountBar from "@/components/SearchAmountBar";

interface Props {
  tabs: TabProps[];
  amount?: number;
}

const Tabs: FC<Props> = ({ tabs, amount }): JSX.Element => {
  return (
    <SearchAmountBar amount={amount}>
      {tabs.map((tab, index) => {
        return <Tab key={index} {...tab}></Tab>;
      })}
    </SearchAmountBar>
  );
};

export default Tabs;
